import React from 'react'
import { TableStyle } from './style'

type ObjCourse = {
  courseName: string
  _id: string
}

type user = {
  _id: string
  name: string
  cpf: string
  email: string
  cellPhone: string
  courses: ObjCourse[]
  isConfirmed: boolean
  confirmCode: string
  updateAt: string
  createAt: string
  __v: number
}

type TableProps = React.FC<{
  usersArrays: user[]
}>

export const Table: TableProps = ({ usersArrays }) => {
  return (
    <TableStyle>
      <thead>
        <tr>
          <th>Data do Cadastro</th>
          <th>Nome</th>
          <th>CPF</th>
          <th>Email</th>
          <th>Telefone | Celular</th>
          <th colSpan={2}>Curso de Interesse</th>
          <th>Cadastro validado?</th>
        </tr>
      </thead>
      <tbody>
        {usersArrays.map((user, index) => (
          <tr key={index + 1}>
            <td>{user.createAt}</td>
            <td>{user.name}</td>
            <td>{user.cpf}</td>
            <td>{user.email}</td>
            <td>{user.cellPhone}</td>
            <td>{user.courses[0] ? user.courses[0].courseName : ''}</td>
            <td>{user.courses[1] ? user.courses[1].courseName : ''}</td>
            <td>{user.isConfirmed ? 'SIM' : 'NÃO'}</td>
          </tr>
        ))}
      </tbody>
    </TableStyle>
  )
}
